// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_56e48c22","message":"_de4005fa","countdown":"_e4e19bc0"};